module.exports = __webpack_public_path__ + "img/img_activation_email_5.edfe5172.png";